import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProductPortraitTileComponent} from './product-portrait-tile.component';
import {AngularSvgIconModule} from "angular-svg-icon";
import {TranslateModule} from "@ngx-translate/core";
import {AddToCartButtonModule} from "@app/presentation/components/add-to-cart-button/add-to-cart-button.module";
import {RouterModule} from "@angular/router";
import {ProductPortraitTileInfoComponent} from './product-portrait-tile-info/product-portrait-tile-info.component';
import {FavButtonModule} from "@app/presentation/components/fav-button/fav-button.module";
import {ProductLabelsModule} from '../product-labels/product-labels.module';
import {LocalizedCurrencyModule} from '@app/presentation/pipes/localized-currency/localized-currency.module';
import {LocalizeRouterModule} from "@gilsdav/ngx-translate-router";
import {LazyLoadDirectiveModule} from "@app/presentation/directives/lazy-load-image/lazy-load.module";
import {
    AddRemovePdfButtonModule
} from "@app/presentation/components/add-remove-pdf-button/add-remove.pdf-button.module";


@NgModule({
  declarations: [
    ProductPortraitTileComponent,
    ProductPortraitTileInfoComponent
  ],
    imports: [
        CommonModule,
        AngularSvgIconModule,
        TranslateModule,
        AddToCartButtonModule,
        RouterModule,
        FavButtonModule,
        ProductLabelsModule,
        LocalizedCurrencyModule,
        LocalizeRouterModule,
        LazyLoadDirectiveModule,
        AddRemovePdfButtonModule
    ],
  exports: [
    ProductPortraitTileComponent,
    ProductPortraitTileInfoComponent
  ]
})
export class ProductPortraitTileModule { }
